import * as types from '../mutation-types';

// state
export const state = {
  complianceTypeId: null,
};

// mutations
export const mutations = {
  [types.SET_COMPLIANCE_TYPE](state, complianceTypeId) {
    state.complianceTypeId = complianceTypeId;
  },
};

// actions
export const actions = {
  setComplianceType({ commit, state, dispatch }, id) {
    commit(types.SET_COMPLIANCE_TYPE, id);
  },
};

// getters
export const getters = {
  complianceTypeId: state => state.complianceTypeId,
};
